export const CTX_SERVER = 'sendRequestImpl'
export const CTX_AI_GROUPING_RESULT = 'aiGroupingResult'
export const VIRTUAL_TAG = 'virtual'
export const CTX_SECTION_DATA = 'sectionInputData'
export const GROUPING_REQUEST_INTERACTION_NAME = 'groupingRequest'

export const GROUPING_MODELS_ERROR = {
    PROTOBUF_NESTING_DEPTH_EXCEEDED: 'PROTOBUF_NESTING_DEPTH_EXCEEDED'
}
